import { createBrowserHistory } from 'history';

const History = props => {
	createBrowserHistory();
}

export default History;


// WEBPACK FOOTER //
// ./src/components/History.js